module.exports = __webpack_public_path__ + "static/media/Headline.8ffc3325.png";